import { Center, Spinner } from '@chakra-ui/react';
import React from 'react';

import { usePortfolio } from '../../api/portfolio';
import { PortfolioAllocationTables } from '../PortfolioAllocationTables';

export const PortfolioAllocationTableTab = ({ pId }: { pId: string }) => {
    const { data: portfolioDetails, isPending } = usePortfolio({ pId });

    if (isPending) {
        return (
            <Center width="100%" height="40vh">
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="teal.500" size="lg" />
            </Center>
        );
    }

    return portfolioDetails ? <PortfolioAllocationTables portfolioGuid={portfolioDetails.base.portfolioGuid} /> : null;
};
